module.exports = __webpack_public_path__ + "img/pluto17.54f56993.jpg";